import React, { useCallback, useEffect, useState } from 'react';
export const Filter = ({ stateRef, marketSpaceships, updateMarketSpaceships, setFiltering, wallet }) => {
  return stateRef !== undefined ? (
    <div className='filter-container'>
      <FilterRarity
        stateRef={stateRef}
        marketSpaceships={marketSpaceships}
        updateMarketSpaceships={updateMarketSpaceships}
        setFiltering={setFiltering}
      />
      {/* <SortByPrice
        stateRef={stateRef}
        marketSpaceships={marketSpaceships}
        updateMarketSpaceships={updateMarketSpaceships}
        setFiltering={setFiltering}
      /> */}

      <ShowOwnOnly
        stateRef={stateRef}
        marketSpaceships={marketSpaceships}
        updateMarketSpaceships={updateMarketSpaceships}
        setFiltering={setFiltering}
        wallet={wallet}
      />
    </div>
  ) : (
    <div style={{ height: '35px' }} className='filter-container'></div>
  );
};

export const FilterRarity = ({ stateRef, marketSpaceships, updateMarketSpaceships, setFiltering }) => {
  const [raririty, setRarity] = useState(0);

  const setActive = (item) => (item === raririty ? 'active' : '');

  const filterArray = useCallback(() => {
    if (raririty === 0) {
      setFiltering(false);
      updateMarketSpaceships(stateRef);
    } else if (raririty === 1) {
      setFiltering(true);
      updateMarketSpaceships(stateRef.filter((ele) => Number(ele.nftData.level) === 1));
    } else if (raririty === 2) {
      setFiltering(true);
      updateMarketSpaceships(stateRef.filter((ele) => Number(ele.nftData.level) === 2));
    } else if (raririty === 3) {
      setFiltering(true);
      updateMarketSpaceships(stateRef.filter((ele) => Number(ele.nftData.level) === 3));
    } else if (raririty === 4) {
      setFiltering(true);
      updateMarketSpaceships(stateRef.filter((ele) => Number(ele.nftData.level) === 4));
    } else if (raririty === 5) {
      setFiltering(true);
      updateMarketSpaceships(stateRef.filter((ele) => Number(ele.nftData.level) === 5));
    }
  }, [raririty, setFiltering, stateRef, updateMarketSpaceships]);

  useEffect(() => {
    filterArray();
  }, [filterArray]);

  return (
    <>
      <label htmlFor='filter-rarity'>
        <span>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
            <g transform='rotate(0, 12, 12) translate(0, 0) scale(1, 1)'>
              <path d='M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' />
            </g>
          </svg>
          <b>Level</b>&nbsp;(And Sort By Price Asc)
        </span>
        <div id='filter-rarity' className='btn-group' role='group' aria-label='Basic example'>
          <button className={`btn btn-light ${setActive(0)}`} type='button' onClick={() => setRarity(0)}>
            All
          </button>
          <button className={`btn btn-light ${setActive(1)}`} type='button' onClick={() => setRarity(1)}>
            1
          </button>
          <button className={`btn btn-light ${setActive(2)}`} type='button' onClick={() => setRarity(2)}>
            2
          </button>
          <button className={`btn btn-light ${setActive(3)}`} type='button' onClick={() => setRarity(3)}>
            3
          </button>
          <button className={`btn btn-light ${setActive(4)}`} type='button' onClick={() => setRarity(4)}>
            4
          </button>
          <button className={`btn btn-light ${setActive(5)}`} type='button' onClick={() => setRarity(5)}>
            5
          </button>
        </div>
      </label>
    </>
  );
};

export const SortByPrice = ({ stateRef, marketSpaceships, updateMarketSpaceships, setFiltering }) => {
  const [priceSorting, setPriceSorting] = useState(0);
  const setActive = (item) => (item === priceSorting ? 'active' : '');

  const filterArray = useCallback(() => {
    if (priceSorting === 0) {
      setFiltering(false);
      updateMarketSpaceships(stateRef);
    } else if (priceSorting === 1) {
      updateMarketSpaceships(marketSpaceships.sort((a, b) => a.price - b.price));
      setFiltering(true);
    } else if (priceSorting === 2) {
      updateMarketSpaceships(marketSpaceships.sort((a, b) => b.price - a.price));
      setFiltering(true);
    }
  }, [marketSpaceships, priceSorting, setFiltering, stateRef, updateMarketSpaceships]);

  useEffect(() => {
    filterArray();
  }, [filterArray]);

  return (
    <>
      <label htmlFor='filter-rarity'>
        <span>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
            <g transform='rotate(0, 12, 12) translate(0, 0) scale(1, 1)'>
              <path d='M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z' />
            </g>
          </svg>
          Price
        </span>
        <div id='filter-rarity' className='btn-group' role='group' aria-label='Basic example'>
          <button className={`btn btn-light`} type='button' onClick={() => setPriceSorting(0)}>
            Reset
          </button>
          <button className={`btn btn-light ${setActive(1)}`} type='button' onClick={() => setPriceSorting(1)}>
            Lower first
          </button>
          <button className={`btn btn-light ${setActive(2)}`} type='button' onClick={() => setPriceSorting(2)}>
            Higher first
          </button>
        </div>
      </label>
    </>
  );
};

export const ShowOwnOnly = ({ stateRef, marketSpaceships, updateMarketSpaceships, setFiltering, wallet }) => {
  const [showOwn, setShowOwn] = useState(false);

  const filterArray = useCallback(() => {
    if (showOwn) {
      setFiltering(true);
      updateMarketSpaceships(stateRef.filter((ele) => ele.sellerAddress === wallet));
    } else {
      setFiltering(false);
      updateMarketSpaceships(stateRef);
    }
  }, [setFiltering, showOwn, stateRef, updateMarketSpaceships, wallet]);

  useEffect(() => {
    filterArray();
  }, [filterArray]);

  return (
    <>
      <label htmlFor='showOwn'>
        <span>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
            <g transform='rotate(0, 12, 12) translate(0, 0) scale(1, 1)'>
              <path d='M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' />
            </g>
          </svg>
          My listings
        </span>
        <button
          className={`btn btn-light ${showOwn ? 'active' : ''}`}
          type='button'
          id='showOwn'
          onClick={() => setShowOwn(!showOwn)}
        >
          {showOwn ? 'Yes' : 'No'}
        </button>
      </label>
    </>
  );
};
